"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OpenGraphImageTag = void 0;
const react_1 = __importDefault(require("react"));
const constants_1 = require("./constants");
const OpenGraphImageTag = ({ imageUrl }) => {
    if (imageUrl) {
        return react_1.default.createElement("meta", { property: "og:image", content: imageUrl });
    }
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("meta", { property: "og:image", content: constants_1.OPEN_GRAPH_DEFAULT_IMAGE_PATH }),
        react_1.default.createElement("meta", { property: "og:image:width", content: constants_1.OPEN_GRAPH_DEFAULT_IMAGE_WIDTH }),
        react_1.default.createElement("meta", { property: "og:image:height", content: constants_1.OPEN_GRAPH_DEFAULT_IMAGE_HEIGHT })));
};
exports.OpenGraphImageTag = OpenGraphImageTag;
//# sourceMappingURL=OpenGraphImageTag.js.map